module.exports = __webpack_public_path__ + "static/media/P.24a91b1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/P.svg
// module id = ./src/App/assets/P.svg
// module chunks = 0